<template>
  <div
    :id="`consignment-card--${consignment.id}`"
    class="cons-card"
    :class="{
      'in_operation': inOperation,
      'cons-card--border-red': consignment.is_outer_reclamation
    }"
  >
    <div class="cons-card__container cons-card__header">
      <div class="cons-card__header-info mb-8">
        <div class="cons-card__header-left">
          <p class="cons-card__title h3" @click="isMobile && collapseAccordion()">
            № Партии: {{ consignment.sort }}
            <svgicon
              v-if="isQrIcon"
              icon="qr-green"
              class="svg-icon--qr-green"
              width="24px"
            />
          </p>
          <p class="cons-card__begin-date">{{ dateFilter(getWorkTime, 'datetime') }}</p>
        </div>

        <div class="cons-card__header-buttons" v-if="canSee">
          <VButton
            v-if="permissionPrintDocumentProduction"
            size="sm"
            icon="print"
            color="grey-sm"
            @click.native="openModal('print')"
          />

          <DropdownMenu :dropdown-is-modal="isModal" dots-class="full-grey" @closeModal="closeModal" @openModal="openModal">
            <VButton
              v-if="isMobile && !hasExecutor && permissionUpdateConsignmentExecutor && visibleStageExecutors"
              text="Назначить исполнителя"
              size="sm"
              icon="set-executor"
              @click.native="openModal('executor')"
            />
            <VButton
              v-if="permissionUpdateConsignment && !this.isLastStage && !this.isLastButOneStage"
              size="sm"
              icon="edit"
              text="Редактировать"
              @click.native="openModal('update')"
            />
            <VButton
              v-if="permissionDestroyConsignment && isFirstStage"
              size="sm"
              icon="remove"
              text="Удалить"
              @click.native="openModal('remove')"
            />
            <VButton
              v-if="permissionSetIndicators"
              text="Добавить индикаторы"
              icon="create"
              size="sm"
              @click.native="openModal('set-indicators')"
            />
          </DropdownMenu>
          <VButton
            v-if="isMobile"
            block="collapse"
            :class="{ open: isOpenAccordion }"
            @click.native="collapseAccordion"
            style="z-index: 2"
            :icon="{ name: 'arrow', dir: isOpenAccordion ? '0' : '180' }"
          />
        </div>
      </div>
      <div class="cons-card__header-buttons consignment__icons">
          <p v-if="isComplaint"
            class="cons-card__complaint"
          >
            <svgicon
              icon="nav/header/reclamation"
              width="18"
            />
            <span>Внеш.</span>
          </p>

          <div class="consignment__icon consignment__icon--red" v-if="isConsignmentReclamation">
            <svgicon
              icon="notification-error"
              class="svg-icon--notification-error svg-icon--red"
              width="34px"
            />
            <span class="consignment__icon--title">Рекламация</span>
          </div>

          <div class="consignment__icon consignment__icon--red" v-if="isUtil">
            <svgicon
              icon="util"
              class="svg-icon--user-avatar"
              width="34px"
            />
            <span class="consignment__icon--title">Утилизация</span>
          </div>

        <IndicatorIcons :indicators="getIndicators" />
      </div>
    </div>

    <div class="cons-card__head">
      <div class="cons-card__head-title">
        <div v-if="consignment.warehouse" class="flex gap-xxs mr-8">
          <svg v-if="consignment.warehouse" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="15" cy="15" r="15" fill="#6699FF"/>
            <rect x="10.8201" y="14.7207" width="8.36" height="7.58" rx="0.5" stroke="white"/>
            <path d="M7.69995 10.9972C7.69995 10.7928 7.82443 10.6089 8.01426 10.533L14.8143 7.81299C14.9335 7.76531 15.0664 7.76531 15.1856 7.81299L21.9856 10.533C22.1755 10.6089 22.3 10.7928 22.3 10.9972V21.8002C22.3 22.0763 22.0761 22.3002 21.8 22.3002H8.19995C7.92381 22.3002 7.69995 22.0763 7.69995 21.8002V10.9972Z" stroke="white"/>
            <path d="M11.1001 17.3398H19.6801" stroke="white"/>
            <path d="M11.1001 19.6807H19.6801" stroke="white"/>
          </svg>
        </div>

        <p>{{ positionName }}</p>
      </div>
      <div class="column gap-xs">
        <div class="flex gap-xxs mr-8">
          <svg v-if="consignment.is_without_winding" width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 6.79685C0 6.11238 0.350032 5.47545 0.927838 5.10852L7.95732 0.644503C8.58185 0.247904 9.37429 0.228454 10.0175 0.593934L17.988 5.12274C18.6136 5.47817 19 6.14219 19 6.86165V17.95C19 19.0546 18.1046 19.95 17 19.95H2C0.895431 19.95 0 19.0546 0 17.95L0 6.79685Z" fill="#6699FF"/>
            <path d="M11.4 11.4002C11.4 12.4467 10.5465 13.3002 9.50004 13.3002C8.45355 13.3002 7.60006 12.4467 7.60006 11.4002C7.60006 10.3537 8.45355 9.50019 9.50004 9.50019C10.5465 9.50019 11.4 10.3537 11.4 11.4002ZM15.2 10.5912C15.2 10.465 15.111 10.3463 14.9848 10.324L13.6266 10.1162C13.5524 9.87129 13.4485 9.62637 13.3223 9.38887C13.5747 9.04004 13.8493 8.71348 14.1016 8.37207C14.1387 8.32012 14.161 8.26816 14.161 8.20137C14.161 8.14199 14.1462 8.08262 14.109 8.03809C13.7973 7.60019 13.2778 7.14004 12.8844 6.77637C12.8325 6.73184 12.7657 6.70215 12.6989 6.70215C12.6321 6.70215 12.5653 6.72441 12.5207 6.76894L11.4669 7.56309C11.2516 7.45176 11.0289 7.36269 10.7989 7.28848L10.5911 5.92285C10.5762 5.79668 10.4575 5.7002 10.3239 5.7002H8.67622C8.54262 5.7002 8.43871 5.78926 8.40902 5.90801C8.29027 6.35332 8.24576 6.83574 8.1938 7.28848C7.96373 7.36269 7.73365 7.45918 7.51841 7.57051L6.49418 6.77637C6.43481 6.73184 6.36802 6.70215 6.30123 6.70215C6.04888 6.70215 5.04693 7.78574 4.8688 8.03066C4.83169 8.08262 4.80199 8.13457 4.80199 8.20137C4.80199 8.26816 4.83168 8.32754 4.87621 8.37949C5.15082 8.71348 5.41802 9.04746 5.67036 9.40371C5.55161 9.62637 5.45513 9.84902 5.38091 10.0865L4.00043 10.2943C3.8891 10.3166 3.80005 10.4502 3.80005 10.5615V12.2092C3.80005 12.3354 3.88912 12.4541 4.01529 12.4764L5.37348 12.6768C5.4477 12.9291 5.55162 13.174 5.67779 13.4115C5.42545 13.7604 5.15084 14.0869 4.89849 14.4283C4.86138 14.4803 4.83911 14.5322 4.83911 14.599C4.83911 14.6584 4.85394 14.7178 4.89106 14.7697C5.20278 15.2002 5.72232 15.6603 6.11568 16.0166C6.16763 16.0686 6.23443 16.0982 6.30123 16.0982C6.36802 16.0982 6.4348 16.076 6.48676 16.0314L7.53325 15.2373C7.74848 15.3486 7.97113 15.4377 8.20121 15.5119L8.40902 16.8775C8.42389 17.0037 8.54262 17.1002 8.67622 17.1002H10.3239C10.4575 17.1002 10.5614 17.0111 10.5911 16.8924C10.7098 16.4471 10.7543 15.9646 10.8063 15.5119C11.0364 15.4377 11.2664 15.3412 11.4817 15.2299L12.5059 16.0314C12.5653 16.0686 12.6321 16.0982 12.6989 16.0982C12.9512 16.0982 13.9532 15.0072 14.1313 14.7697C14.1758 14.7178 14.1981 14.6658 14.1981 14.599C14.1981 14.5322 14.1684 14.4654 14.1239 14.4135C13.8493 14.0795 13.5821 13.7529 13.3297 13.3893C13.4485 13.174 13.5375 12.9514 13.6192 12.7139L14.9922 12.5061C15.111 12.4838 15.2 12.3502 15.2 12.2389V10.5912Z" fill="white"/>
          </svg>
          <InfoTextBlock
            labelText="Заказ"
            :text="consignment.order ? consignment.order.account_number : '-'"
          />
        </div>
        <InfoTextBlock
          labelText="Этап"
          :text="consignment.status ? consignment.status.name : '-'"
        />
      </div>

    </div>

    <AccordionCard
      :is-open="!isMobile || isOpenAccordion"
      class="cons-card__accordion"
    >
      <div class="cons-card__body">
        <!--   TODO ConsignmentInfo     -->
        <div class="column gap-xs">
          <InfoTextBlock
            v-if="isConsignmentsList"
            labelText="Дата отгрузки"
            :text="consignment.order ? dateFilter(consignment.order.date_finished, 'date') : '-'"
          />
          <InfoTextBlock
            labelText="Кол-во"
            :text="consignment.value"
          />
          <InfoTextBlock
            v-if="consignment.probes"
            labelText="Кол-во пробников"
            :text="consignment.probes"
          />
          <InfoTextBlock
            v-if="consignment.defect"
            labelText="Кол-во брака"
            :text="consignment.defect"
          />
          <InfoTextBlock
            v-if="visibleStageExecutors"
            labelText="Ответственный"
            :length="20"
            :has-tooltip="!isMobile"
            :text="consignment.responsible ? fullName(consignment.responsible.surname, consignment.responsible.name) : ''"
          />
          <InfoTextBlock
            v-if="!isMobile"
            labelText="Общий вес"
            :text="getDirtyWeigthText"
            :use-click-event="showModalWeightWithLength"
            @clickLink="openModal('show-weight-dirty')"
          />
          <InfoTextBlock
            v-if="visibleStageExecutors && hasExecutor"
            labelText="Исполнитель"
            :length="20"
            :has-tooltip="!isMobile"
            :text="hasExecutor ? fullName(consignment.executor.surname, consignment.executor.name) : ''"
          />
        </div>
      </div>
    </AccordionCard>

    <div class="cons-card__container cons-card__buttons-wrap" v-if="canSee">
      <VButton
        v-if="!hasExecutor && permissionUpdateConsignmentExecutor && visibleStageExecutors && !isMobile"
        text="Назначить исполнителя"
        class="mb-16"
        size="100"
        @click.native="openModal('executor')"
      />
      <div class="buttons mobile-full">
        <router-link :to="{ name: 'DetailedConsignment', params: { id_cons: consignment.id, positionIndex: positionIdx } }" class="btn--info">
          <VButton
            text="Информация"
            size="100"
            @click.native="goToConsignment"
          />
        </router-link>

        <VTooltip
          v-if="permissionUpdateConsignmentStageNext && additionalVerificationPermissionUpdateConsignmentStage"
          popupText="Добавьте общий вес, чтобы переместить партию на след. этап"
          :showTip="false"
          tooltipSide="top"
          style="width: 100%"
          class="btn--stage-next"
        >
          <VButton
            v-if="inOperation"
            text="След. этап"
            color="primary"
            size="100"
            mod="row-reverse"
            icon="arrow-next"
            direction="row-reverse"
            :disabled="isLastStage"
            :loading="isLoadingStageLine"
            @click.native="openModalStageNext"
          />
          <VButton
            v-else
            text="Принять"
            color="green-full"
            size="100"
            icon="check"
            direction="row-reverse"
            :loading="isLoadingStageLine"
            @click.native="openModal('at_work')"
          />
        </VTooltip>
      </div>
    </div>

    <ModalConsignmentRemove
      v-if="isModal === 'remove'"
      :consignment-id="consignment.id"
      @remove="removeHandler"
      @reject="closeModal"
    />

    <ModalConsignmentAddExecutor
      v-if="isModal === 'executor'"
      :consignment-id="consignment.id"
      @addExecutorHandler="addExecutorHandler"
      @reject="closeModal"
    />

    <ModalConsignmentUpdate
      v-if="isModal === 'update'"
      :consignment="consignment"
      :position="position || consignment.position"
      @updateHandler="updateHandler"
      @reject="closeModal"
    />

    <ModalConsignmentSplit
      v-if="isModal === 'stage-next'"
      :consignment="consignment"
      :isFirstStage="isFirstStage"
      :stage-line="modalStageNext.stageLine"
      :reserve-data="getReservedData"
      :position="position || consignment.position"
      :is-order-detail="!isConsignmentsList"
      @goStageNext="goStageNext"
      @goSplit="goSplit"
      @reject="closeModal"
    />

    <ModalConsignmentSplitPrint
      v-if="isModal === 'split-print'"
      @goSplitPrint="goSplitPrint"
      :consignment-id="consignment.id"
      :consignment-split-id="getSplitConsignmentId"
      @request="openModalPreview"
    />

    <ModalConsignmentPrint
      v-if="isModal === 'print' && consignmentPositionId"
      :consignment-id="consignment.id"
      :is-inner-reclamation="consignment.is_inner_reclamation"
      :position-id="consignmentPositionId"
      @close="closeModal"
      @request="openModalPreview"
    />

    <ModalFilesPreview
      v-if="isModal === 'files_preview'"
      :files="files"
      @close="closeModalPreview"
    />

    <ModalConsignmentWorkTime
      v-if="isModal === 'at_work'"
      :consignment="consignment"
      @workTime="workTime"
      @close="closeModal"
    />

    <ModalSetIndicators
      v-if="isModal === 'set-indicators'"
      :id="consignment.id"
      :indicators="getIndicators"
      @setIndicators="setIndicators"
      @reject="closeModal"
    />

    <ModalConsignmentShowWeightDirty
      v-if="isModal === 'show-weight-dirty'"
      :position="position || consignment.position"
      :consignment="consignment"
      @reject="closeModal"
    />
  </div>
</template>

<script>
import InfoTextBlock from '../../ui/AppInfoTextBlock'
import ModalConsignmentPrint from '@/components/ui/Modal/Production/Consignment/ModalConsignmentPrint'
import ModalConsignmentRemove from '@/components/ui/Modal/Production/Consignment/ModalConsignmentRemove'
import ModalConsignmentSplit from '@/components/ui/Modal/Production/Consignment/ModalConsignmentSplit'
import ModalConsignmentSplitPrint from '@/components/ui/Modal/Production/Consignment/ModalConsignmentSplitPrint'
import VButton from '@/components/simple/button/VButton'
import VTooltip from '../../ui/VTooltip'

import { mixinModal } from '@/mixins/modal/mixinModal'
import { mixinConsignment } from '@/mixins/views/Production/Consignment/mixinConsignment'

import { mapGetters, mapState } from 'vuex'
import { fullName } from '@/utils/string'
import ConsignmentController from '@/controllers/production/Consignment/ConsignmentController'
import ModalFilesPreview from '@/components/files/ModalFilesPreview.vue'
import ModalConsignmentUpdate from '@/components/ui/Modal/Production/Consignment/ModalConsignmentUpdate.vue'
import ModalConsignmentAddExecutor from '@/components/ui/Modal/Production/Consignment/ModalConsignmentAddExecutor.vue'
import ModalConsignmentWorkTime from '@/components/ui/Modal/Production/Consignment/ModalConsignmentWorkTime.vue'
import DropdownMenu from '@/components/ui/DropdownMenu.vue'
import AccordionCard from '@/components/accordionList/AccordionCard.vue'
import { mixinAccordion } from '@/mixins/mixinAccordion'
import { dateFilter } from '@/filters/date.filter'
import { mixinInOperation } from '@/mixins/views/Production/Consignment/mixinInOperation'
import { getCurrentIndicators } from '@/entities/order/model'
import { getResponseList } from '@/utils/apiResponse'
import IndicatorIcons from '@/components/production/IndicatorIcons.vue'
import ModalSetIndicators from '@/components/ui/Modal/Production/ModalSetIndicators.vue'
import ModalConsignmentShowWeightDirty
  from '@/components/ui/Modal/Production/Consignment/ModalConsignmentShowWeightDirty.vue'

export default {
  name: 'ConsignmentCard',
  components: {
    ModalConsignmentShowWeightDirty,
    ModalSetIndicators,
    IndicatorIcons,
    ModalConsignmentWorkTime,
    AccordionCard,
    DropdownMenu,
    ModalConsignmentAddExecutor,
    ModalFilesPreview,
    ModalConsignmentUpdate,
    ModalConsignmentRemove,
    InfoTextBlock,
    ModalConsignmentPrint,
    ModalConsignmentSplit,
    ModalConsignmentSplitPrint,
    VButton,
    VTooltip
  },
  mixins: [
    mixinModal,
    mixinConsignment,
    mixinAccordion,
    mixinInOperation
  ],
  props: {
    consignment: {
      type: Object,
      required: true
    },
    position: {
      type: Object
    },
    isComplaint: {
      type: Boolean,
      default: false
    },
    stageLine: {
      type: Array,
      default: () => []
    },
    positionIdx: {
      type: Number
    },
    isConsignmentsList: {
      type: Boolean,
      default: false
    },
    reservedData: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      isLoadingStageLine: false,

      formData: {
        value: '',
        winding_method: null,
        executor_person: {}
      },

      modalHandlers: {
        setLoading: (bool) => this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', bool),
        close: this.closeModal
      },

      modalStageNext: {
        stageLine: []
      },

      consignmentSplit: {},

      // preview files print
      files: []
    }
  },

  computed: {
    ...mapGetters({
      executorList: 'users/executorList',

      countMaterialByArticle: 'warehouse/countMaterialByArticle'
    }),

    ...mapGetters('permission', {
      permissionPrintDocumentProduction: 'permissionPrintDocumentProduction',
      permissionUpdateConsignment: 'permissionUpdateConsignment',
      permissionUpdateConsignmentStageNext: 'permissionUpdateConsignmentStageNext',
      permissionUpdateConsignmentWeight: 'permissionUpdateConsignmentWeight',
      permissionUpdateConsignmentExecutor: 'permissionUpdateConsignmentExecutor',
      permissionDestroyConsignment: 'permissionDestroyConsignment',
      permissionSetIndicators: 'permissionSetIndicators'
    }),

    ...mapState('mobile', {
      isMobile: 'isMobile'
    }),

    isConsignmentReclamation () {
      return this.consignment.inner_reclamations?.length
    },
    isUtil () {
      return this.consignment.is_scrap
    },
    consignmentStatusId () {
      return this.consignment?.status?.id ?? this.consignment?.status_id ?? null
    },
    consignmentStatusesLine () {
      if (Array.isArray(this.consignment?.statuses_line?.statuses)) return this.consignment.statuses_line.statuses
      if (Array.isArray(this.stageLine)) return this.stageLine
      return []
    },
    positionName () {
      if (this.consignment?.position?.type?.name) {
        let name = this.consignment.position.type.name.split(' ')
        name = [name[0], name[1]?.toUpperCase()]
        name = name.join(' ')
        const value = this.consignment.position?.value
        const id = this.consignment.position?.sort
        return `№${id} ${name} (${value})`
      } else {
        return '-'
      }
    },

    isFirstStage () {
      const firstStage = this.consignmentStatusesLine?.[0]
      const firstStageStatusId = firstStage?.status_id ?? firstStage?.status?.id
      return !!this.consignmentStatusId && !!firstStageStatusId && this.consignmentStatusId === firstStageStatusId
    },

    isLastButOneStage () {
      const stage = this.consignmentStatusesLine[this.consignmentStatusesLine.length - 2]
      const stageStatusId = stage?.status_id ?? stage?.status?.id
      return !!this.consignmentStatusId && !!stageStatusId && this.consignmentStatusId === stageStatusId
    },

    hasExecutor () {
      return this.consignment.executor
    },

    hasDirtyWeight () {
      if (this.consignment.warehouse) return true
      if (this.consignment.is_without_winding) return true
      return !!this.consignment?.weight_dirty
    },

    visibleStageExecutors () {
      switch (this.consignment.status?.flag_id) {
        case 5:
        case 4:
        case 3: return false
        default: return true
      }
    },

    windingMethodOptionsFiltered () {
      return this.$store.state.records.properties.winding_method.filter(windingMethod => {
        if (!windingMethod.workshops?.length) return false

        const workshopId = this.position?.workshop_id || this.consignment.position?.workshop_id

        for (const windingMethodWorkshop of windingMethod.workshops) {
          if (workshopId === windingMethodWorkshop.id) return true
        }

        return false
      })
    },

    getSplitConsignmentId () {
      return this.consignmentSplit?.id || null
    },
    consignmentPositionId () {
      return this.position?.id ?? this.consignment?.position?.id ?? null
    },

    isQrIcon () {
      return this.$store.state.registerPage.queryParams?.consignment_id
        && +this.$store.state.registerPage.queryParams?.consignment_id === this.consignment.id
    },

    getWorkTime () {
      return this.consignment?.time_at_work_logs?.length && this.consignment?.time_at_work_logs[0]?.created_at
        ? this.consignment.time_at_work_logs[0].created_at
        : null
    },

    canSee () {
      return !this.isConsignmentsList || (this.isConsignmentsList && this.consignment?.can_see)
    },

    getIndicators () {
      return getCurrentIndicators(this.consignment)
    },

    // Получение резерва для текущей позиции
    getReservedData () {
      return this.isConsignmentsList ? (this.consignment?.position_reserved ?? []) : this.reservedData
    },

    // Получение текста для поля "Общий вес"
    getDirtyWeigthText () {
      return this.consignment?.dirty_weights?.length
        ? 'Подробнее'
        : (this.consignment?.weight_dirty ? this.consignment.weight_dirty : '-')
    },

    // Выводить ли модальное окно с подробным общим весом
    showModalWeightWithLength () {
      return !!this.consignment?.dirty_weights?.length
    }
  },

  methods: {
    dateFilter,
    fullName,

    goToConsignment () {
      this.$emit('goToConsignment', this.consignment.id)
    },

    addDirtyWeightHandler (data) {
      this.closeModal()
      this.$emit('addDirtyWeight', data)
    },

    addExecutorHandler (data) {
      this.closeModal()
      this.$emit('addExecutor', data)
    },

    // modalStageNext
    goStageNext (data, dirtyWeightData) {
      this.closeModalStageNext()
      this.$emit('goStageNext', data, dirtyWeightData)
    },

    goSplit (data, dirtyWeightData) {
      this.consignmentSplit = data
      this.$emit('goSplit', data, dirtyWeightData)
      this.closeModalSplit()
      this.openModal('split-print')
    },

    goSplitPrint () {
      this.$emit('goSplitPrint', this.consignmentSplit)
      this.closeModal()
    },

    // response modal work time
    workTime (data) {
      this.closeModal()
      this.$emit('workTime', data)
    },

    // После успешной установки индикаторов закрываем модальное окно и выполняет setIndicators
    async setIndicators (data) {
      this.closeModal()
      this.$emit('setIndicators', data)
    },

    async openModalStageNext () {
      if (this.isConsignmentReclamation && this.consignment.inner_reclamations?.[0]?.type === 'rework') {
        await this.setModalStageNextStageLine()
      }

      this.openModal('stage-next')
    },

    closeModalStageNext () {
      this.closeModal()
      this.modalStageNext.stageLine = []
    },

    closeModalSplit () {
      this.closeModal()
      this.modalStageNext.stageLine = []
    },

    async setModalStageNextStageLine () {
      let stageLine = []

      if (this.stageLine.length) {
        stageLine = this.stageLine
      } else {
        try {
          this.isLoadingStageLine = true
          const response = await ConsignmentController.getStageLine(this.consignment.id)
          if (response?.status !== 200) return
          stageLine = getResponseList(response.data)
        } finally {
          this.isLoadingStageLine = false
        }
      }

      this.modalStageNext.stageLine = stageLine
    },

    removeHandler () {
      const data = {
        id: this.consignment?.id,
        value: this.consignment?.value,
        article: this.consignment?.position?.article || ''
      }

      this.closeModal()
      this.$emit('remove', data)
    },

    updateHandler (data) {
      this.$emit('update', data, this.modalHandlers)
    },

    openModalPreview (file) {
      this.files.length = 0
      this.files.push(file)
      this.openModal('files_preview')
    },

    closeModalPreview () {
      this.files = []
      this.closeModal()

      if (this.consignmentSplit?.id) {
        this.$emit('goSplitPrint', this.consignmentSplit)
        this.consignmentSplit = {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cons-card {
  display: flex;
  flex-direction: column;
  border: 1px solid transparent;
  border-radius: 20px;
  width: 345px;
  background: #FFFFFF;
  box-shadow: $color__card-box-shadow;
  transition: ease-in-out $transition box-shadow;

  &:not(.in_operation) {
    background-color: transparent;
    box-shadow: none;
    border-color: $color__gray-blue;
  }

  &--border-red {
    border-color: $color__red !important;
  }

  &:hover {
    box-shadow: $color__card-box-shadow--hover;
  }

  @media screen and (max-width: $desktop-width) {
    width: calc(100% / 4 - 15px);
  }

  @media screen and (max-width: $desktop-width-m) {
    width: calc(100% / 3 - 15px);
  }

  @media screen and (max-width: $tablet-width) {
    width: calc(100% / 2 - 15px);
  }

  &__header {
    position: relative;
    border-bottom: 1px solid $color__card-inner-border;

    &-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-left {
      margin-right: 16px;
    }
  }

  .cons-card__title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: $color__main;
    font-size: 20px;
  }

  .cons-card__compl {
    display: flex;
    align-items: center;
    color: $color__periwinkle-crayola;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: var(--letter-spacing);
    margin-left: 4px;
  }

  .cons-card__complaint {
    display: flex;
    flex-wrap: nowrap;
    gap: 2px;
    align-items: center;
    color: $color__orange;

    & > span {
      display: block;
    }
  }

  &__header-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .cons-card__delete {
    margin-right: 20px;
  }

  &__body {
    padding: var(--xs) var(--s) var(--s);
  }
  &__head {
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0;

    &-title {
      font-weight: 600;
      color: $color__font--dark;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
    }
  }

  .cons-card__item {
    display: flex;
    color: $color__main;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: var(--letter-spacing);
    margin-bottom: 14px;
  }

  &__container {
    padding: 20px;
  }

  &__buttons-wrap {
    margin-top: auto;
    padding-top: 0;

    & .btn--info {
      width: 100%;

      @media screen and (max-width: $mobile-width) {
        width: 100%;
      }
    }

    & .btn--stage-next {
      .btn {
        @media screen and (max-width: $mobile-width) {
          max-width: 100%;
        }
      }
    }
  }

  @media screen and (max-width: $tablet-width-s) {
    width: 100%;

    &__buttons-wrap {
      order: 1;
      padding: 0 var(--xs-mobile) var(--s) var(--xs-mobile);

      & .buttons {
        max-width: 350px;
      }
    }

    &__body {
      padding: 0 var(--xs-mobile) var(--xs-mobile) var(--xs-mobile);
    }

    &__head {
      padding: var(--xs-mobile);

      &-title {
        margin-bottom: var(--xs-mobile);
      }
    }

    &__accordion {
      order: 2;
    }

    &__header {
      border-bottom: none;
      padding-bottom: 0;
      margin-bottom: var(--xxs);
      padding: var(--xs-mobile) var(--xs-mobile) 0 var(--xs-mobile);
    }
  }

  &__begin-date {
    @include font14;
    color: $color__red;
    margin-top: 6px;
  }
}

.icon-warehouse {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  color: var(--color__white);
  background-color: $color__green;
  box-shadow: none;
}
</style>
